'use client'

import { useEffect } from 'react'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white">
      <div className="w-full max-w-md rounded-lg bg-white p-8 text-center shadow-lg">
        <h2 className="text-primary-main mb-4 text-2xl font-semibold">
          Something went wrong
        </h2>
        <p className="text-neutral-80 mb-6 text-base">
          An unexpected error occurred. Please try again.
        </p>
        <button
          onClick={() => reset()}
          className="bg-primary-main text-neutral-10 hover:bg-primary-hover rounded-lg px-6 py-3 font-medium transition-colors"
        >
          Try again
        </button>
      </div>
    </div>
  )
}
